module.exports = __webpack_public_path__ + "img/ceshi.f887a686.jpg";